module.exports = __webpack_public_path__ + "img/2016年上海国药会.7cabf942.jpg";